import { api } from '@/api';
import type { Criterios, Desempenho, Eu } from './types';

export const buscaEu = (signal?: AbortSignal) => api.get<Eu>('/eu', { signal });
export const buscaDesempenho = (semestre?: string, signal?: AbortSignal) =>
  api.get<Desempenho>('/desempenho', { signal, query: { semestre } });

export const pedeVinculo = (dados: { ra: string; nome: string; email: string }) =>
  api.post<{ email: string; validadeHoras: number }>('/vinculo', dados);
export const cancelaPendente = () => api.delete<void>('/vinculo/pendente');
export const confirmaVinculo = (token: string) =>
  api.post<{ ok: true; nome: string }>('/vinculo/confirmar', { token }, { auth: false });

// professor
export interface ResumoAdmin {
  turmas: {
    codigo: string;
    nome: string;
    periodo: string;
    turma: string;
    alunos: number;
    vinculados: number;
    media_p1: number | null;
    p1_acima_6: number;
    sem_entrega: number;
  }[];
  contas: { contas: number; vinculadas: number; ativas_7d: number };
  importacao: { semestre: string; gerado_em: string; importado_em: string } | null;
}

export interface AlunoAdmin {
  ra: string;
  nome: string;
  emails_cps: string[];
  matriculas: {
    semestre: string;
    disciplina: string;
    notas: Record<string, number | null>;
    pendencias: string[];
    grupo: number | null;
    foraDoPrazo: boolean | null;
    aws: string | null;
  }[];
  conta_google: string | null;
  email_cps: string | null;
  vinculado_em: string | null;
  ultimo_acesso: string | null;
  pendente_desde: string | null;
}

export const buscaResumoAdmin = (semestre?: string, signal?: AbortSignal) =>
  api.get<ResumoAdmin>('/admin/resumo', { signal, query: { semestre } });
export const buscaAlunosAdmin = (semestre?: string, signal?: AbortSignal) =>
  api.get<AlunoAdmin[]>('/admin/alunos', { signal, query: { semestre } });
export const buscaDesempenhoAdmin = (ra: string, semestre?: string, signal?: AbortSignal) =>
  api.get<Desempenho>(`/admin/alunos/${ra}/desempenho`, { signal, query: { semestre } });

export interface SemestreAdmin {
  semestre: string;
  publicado: boolean;
  publicado_em: string | null;
  publicado_por: string | null;
  alunos: number;
  disciplinas: number;
}
export const buscaSemestresAdmin = (signal?: AbortSignal) => api.get<SemestreAdmin[]>('/admin/semestres', { signal });

export interface StatusPublicacao {
  aprovado: boolean;
  atualizado_em: string;
  atualizado_por: string | null;
}
export interface GrupoPublicacao {
  numero: number;
  fora: boolean;
  nota: number | null;
  repositorio: string | null;
  integrantes: string[];
  ras: string[];
  requisitos: { id: string; status: string | null; nota: number | null; justificativa: string | null }[] | null;
  status: StatusPublicacao | null;
}
export interface DisciplinaPublicacao {
  codigo: string;
  nome: string;
  periodo: string;
  somenteNotas: boolean;
  requisitos: { id: string; nome: string; secao: string | null; peso: number | null }[];
  criterios: Criterios | null;
  criteriosStatus: StatusPublicacao | null;
  grupos: GrupoPublicacao[];
}
export const buscaPublicacoes = (semestre?: string, signal?: AbortSignal) =>
  api.get<{ semestre: { semestre: string; publicado: boolean; publicado_em?: string; publicado_por?: string }; disciplinas: DisciplinaPublicacao[] }>(
    '/admin/publicacoes',
    { signal, query: { semestre } },
  );
export const publica = (dados: {
  semestre: string;
  escopo: 'grupo' | 'criterios' | 'disciplina' | 'tudo' | 'semestre';
  disciplina?: string;
  grupo?: number;
  aprovado: boolean;
}) => api.post<void>('/admin/publicacoes', dados);
export const desfazVinculoAdmin = (ra: string) => api.delete<void>(`/admin/alunos/${ra}/vinculo`);
export const adicionaEmailAdmin = (ra: string, email: string) => api.post<void>(`/admin/alunos/${ra}/emails`, { email });
export const emailTesteAdmin = (para?: string) => api.post<{ ok: true; para: string }>('/admin/email-teste', para ? { para } : {});

// aceite de ofertas de conteúdo
export const mudaOfertas = (aceita: boolean) => api.post<{ ofertas: boolean }>('/preferencias/ofertas', { aceita });
export const mudaCelular = (celular: string | null, contato: boolean) =>
  api.post<{ celular: string | null; celularContato: boolean }>('/preferencias/celular', { celular, contato });
export const leOfertasPorLink = (ra: string, t: string) =>
  api.get<{ nome: string; ofertas: boolean }>('/preferencias/link', { auth: false, query: { ra, t } });
export const mudaOfertasPorLink = (ra: string, t: string, aceita: boolean) =>
  api.post<{ ofertas: boolean }>('/preferencias/link', { ra, t, aceita }, { auth: false });

export interface ContatoAdmin {
  ra: string;
  nome: string;
  cps: string | null;
  emails_cps: string[];
  ofertas: boolean;
  ofertas_em: string | null;
  /** só vem preenchido enquanto o aluno deixa o contato por celular ligado */
  celular: string | null;
  celular_contato: boolean;
  celular_em: string | null;
  temCelular: boolean;
  semestres: string[];
  disciplinas: string[];
  pessoais: { email: string; origem: 'login' | 'professor' | 'aws' | 'formulario'; detalhe: string | null }[];
  preferido: string | null;
  linkPreferencias: string;
}
export const buscaContatos = (signal?: AbortSignal) => api.get<ContatoAdmin[]>('/admin/contatos', { signal });
